import { render, staticRenderFns } from "./unplugged.vue?vue&type=template&id=3afaddaf&"
import script from "./unplugged.vue?vue&type=script&lang=js&"
export * from "./unplugged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports